var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJavascriptIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 75,
    viewBox: "0 0 67 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_871_357)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4333 0H0.73291L6.89006 66.7869L33.5831 74.3566L60.2761 66.7869L66.4333 0Z",
    fill: "#E6A329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5831 5.43274V68.6884L55.2055 62.5674L60.4572 5.43274H33.5831Z",
    fill: "#F1BF22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7869 13.6362H17.5383L15.2203 38.6451L15.2747 38.4821H43.5251L42.6015 49.0579L33.5831 51.6476L24.4379 49.0217L23.8947 42.611H15.5825L16.7596 55.4143L33.565 60.1951L50.3885 55.4143L52.7065 30.2967H22.7357L23.116 21.9303H43.9054L44.2133 26.7292H52.5797L50.7869 13.6362Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5831 13.6362H17.5383L15.2203 38.6451L15.2747 38.4821H33.6012V30.333H23.9128L24.2931 21.9665H33.5831V13.6362ZM23.9128 42.6291H15.5825L16.7596 55.4143L33.565 60.177V51.6657L24.4198 49.0217L23.9128 42.6291Z",
    fill: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.73291,
    width: 65.7004,
    height: 74.5015,
    style: {
      mixBlendMode: "saturation"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_871_357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.7004,
    height: 74.5015,
    fill: "white",
    transform: "translate(0.73291)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascriptIcon);
export default __webpack_public_path__ + "static/media/javascript-icon.354b6f951ef91d387998e4a5fb95c4e0.svg";
export { ForwardRef as ReactComponent };